import SvgIcon from 'components/Globals/Base/SvgIcon';
import { SubscribeButton, Title, TitleWrapper, Wrapper } from './SubscriptionTileStyles';

export interface SubscriptionTileProps {
  title: string;
  subscriptionStatus: 'subscribed' | 'unsubscribed' | 'recently-unsubscribed';
  onClick: () => void;
}

const NewsletterSubscriptionTile = ({ title, subscriptionStatus, onClick }: SubscriptionTileProps) => (
  <Wrapper className={`${subscriptionStatus === 'subscribed' ? 'checkmark' : ''}`}>
    <TitleWrapper className={subscriptionStatus !== 'recently-unsubscribed' ? '' : 'recently-unsubscribed'}>
      <Title>{title}</Title>
    </TitleWrapper>
    <SubscribeButton
      onClick={onClick}
      aria-label={subscriptionStatus === 'subscribed' ? 'Unsubscribe' : 'Subscribe'}
    >
      {subscriptionStatus === 'subscribed' ? <SvgIcon name='MinusCircle' /> : <SvgIcon name='PlusCircle' />}
    </SubscribeButton>
  </Wrapper>
);

export default NewsletterSubscriptionTile;
